export var AccountLogoTestSubjects;
(function (AccountLogoTestSubjects) {
    AccountLogoTestSubjects["AccountLogoCheckbox"] = "account-logo-checkbox";
})(AccountLogoTestSubjects || (AccountLogoTestSubjects = {}));
export var AccountLogoKnownErrors;
(function (AccountLogoKnownErrors) {
    AccountLogoKnownErrors["LogoNotFound"] = "ACCOUNT_LOGO/ACCOUNT_LOGO_NOT_FOUND";
})(AccountLogoKnownErrors || (AccountLogoKnownErrors = {}));
//# sourceMappingURL=account-logo.js.map